import React from 'react'
import HotelDateInput from '../../geoentity/HotelDateInput'
import SVGIcon from '../../svg/SVGIcon'
import { getCurrentDateISO, getFutureDateISO, getTomorrowDateISO, isDateAfterOrEqual } from '../../utils/date'
import s from './DatesPickerHotel.less'

const DatesPickerHotel = ({ fromDateLabel, toDateLabel, currentFromDate, currentToDate, onDateChange }) => {
  const getFromToDates = (input, value) => {
    if (input === 'from') {
      const fromDate = value
      return {
        fromDate,
        toDate:
          currentToDate && !isDateAfterOrEqual(fromDate, currentToDate)
            ? currentToDate
            : getFutureDateISO({ days: 1 }, fromDate)
      }
    } else {
      const toDate = value
      return {
        toDate,
        fromDate: currentFromDate || getFutureDateISO({ days: -1 }, toDate)
      }
    }
  }

  const getOnChange = inputName => value => {
    if (!value) inputName === 'from' ? (value = getCurrentDateISO()) : (value = getTomorrowDateISO())
    const { fromDate, toDate } = getFromToDates(inputName, value)
    onDateChange({ fromDate, toDate })
  }

  return (
    <div className={s.container}>
      <HotelDateInput
        label={fromDateLabel}
        date={currentFromDate}
        ariaLabel={'from'}
        picker={{
          onChange: getOnChange('from')
        }}
      />

      <div className={s.toDate}>
        <HotelDateInput
          label={toDateLabel}
          date={currentToDate}
          ariaLabel={'to'}
          picker={{
            onChange: getOnChange('to'),
            min: getFutureDateISO({ days: 1 }, currentFromDate)
          }}
        />
      </div>

      <SVGIcon icon={'calendar'} className={s.calendarIcon} />
    </div>
  )
}

export default DatesPickerHotel
